import { render, staticRenderFns } from "./jiaru1.vue?vue&type=template&id=274689e2&scoped=true"
import script from "./jiaru1.vue?vue&type=script&lang=js"
export * from "./jiaru1.vue?vue&type=script&lang=js"
import style0 from "./jiaru1.vue?vue&type=style&index=0&id=274689e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274689e2",
  null
  
)

export default component.exports